import { render, staticRenderFns } from "./xuanzeImg.vue?vue&type=template&id=fa720c04&scoped=true&"
import script from "./xuanzeImg.vue?vue&type=script&lang=js&"
export * from "./xuanzeImg.vue?vue&type=script&lang=js&"
import style0 from "./xuanzeImg.vue?vue&type=style&index=0&id=fa720c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa720c04",
  null
  
)

export default component.exports